import { memo } from 'react'

interface ILogoProps {
  className?: string
}

const LogoPWAComponent = ({ className = 'fill-primary' }: ILogoProps) => {
  return (
    <svg
      width="241"
      height="42"
      viewBox="0 0 241 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M224.796 10.4578H219.694V34.4258H224.796V24.8044C225.858 24.8044 227.638 24.8044 228.562 24.5647L234.589 34.4258H240.375V33.6726L233.048 22.5788C234.52 21.1065 235.342 18.9493 236.061 16.2101C236.575 14.3954 237.602 13.8133 239.519 13.9845V10.4921C234.246 9.39638 232.158 11.7247 231.336 14.7036C230.685 17.4085 230.206 19.2233 228.939 19.9081C227.98 20.3874 226.268 20.3532 224.796 20.3532V10.4578Z"
        fill="white"
      />
      <path
        d="M211.974 30.3512V14.4296H215.09V10.4578H203.722V14.4296H206.838V30.3512H203.448V34.4258H215.364V30.3512H211.974Z"
        fill="white"
      />
      <path
        d="M191.359 10.4578H186.223V34.4258H201.357V29.8376H191.359V10.4578Z"
        fill="white"
      />
      <path
        d="M180.955 17.5798C180.955 13.0943 177.805 10.4921 173.422 10.4921H163.253V34.4258H174.381C179.174 34.4258 181.982 31.5497 181.982 27.3382C181.982 24.8729 180.783 22.9212 178.558 21.9967C180.064 21.0722 180.955 19.326 180.955 17.5798ZM173.045 14.8748C174.826 14.8748 175.956 16.0047 175.921 17.751C175.887 19.3602 174.791 20.319 173.045 20.319H168.354V14.8748H173.045ZM173.799 24.4962C174.586 24.4962 175.271 24.5647 175.853 24.9756C176.572 25.4892 176.949 26.3794 176.914 27.3382C176.812 28.9474 175.784 29.9746 174.038 29.9746H168.354V24.4962H173.799Z"
        fill="white"
      />
      <path
        d="M148.391 34.734C153.459 34.734 157.876 31.8236 157.876 26.4479V10.4578H152.808V26.3452C152.808 28.9132 150.754 30.2143 148.391 30.2143C146.029 30.2143 143.94 28.9132 143.94 26.3452V10.4578H138.804V26.4479C138.804 31.8236 143.324 34.734 148.391 34.734Z"
        fill="white"
      />
      <path
        d="M121.743 34.3916V27.6121H126.845C132.323 27.6121 135.371 23.606 135.371 19.1548C135.371 14.6351 132.426 10.4236 126.845 10.4236C123.421 10.4236 120.031 10.3894 116.607 10.4236V34.3916H121.743ZM121.641 23.2294V14.909C123.387 14.909 125.099 14.8748 126.845 14.909C129.105 14.909 130.474 16.7922 130.474 19.0178C130.474 21.3119 129.036 23.2294 126.845 23.2294H121.641Z"
        fill="white"
      />
      <path
        d="M111.668 10.4578H96.9786V34.4258H111.941V29.7692H102.149V24.2908H111.051V19.8053H102.149V14.9432H111.668V10.4578Z"
        fill="white"
      />
      <path
        d="M87.7541 25.6947C90.4933 24.3593 92.0342 21.6886 92.0342 18.6412C92.0342 14.3954 89.0553 10.4236 83.5769 10.4236C80.1529 10.3894 76.7631 10.4236 73.3391 10.4236V34.3916H78.4751V26.4822H82.7551L87.6857 34.3916H93.1641V33.6726L87.7541 25.6947ZM78.4066 22.2707V14.909H83.5426C85.734 14.909 87.0693 16.5183 87.0693 18.5385C87.1036 20.5929 85.6997 22.2707 83.5426 22.2707H78.4066Z"
        fill="white"
      />
      <g clipPath="url(#clip0_1255_6784)">
        <path
          d="M0.624702 0.932068V34.4721L36.868 34.3636C39.609 34.3636 41.699 35.0322 43.3423 37.3634C43.4016 37.448 43.4873 37.5118 43.5516 37.5916C45.8855 40.5196 48.8392 41.737 52.3664 41.4929C53.1427 41.4386 53.4147 41.1227 53.4031 40.3153L53.4081 35.0258C53.4345 34.0142 53.1131 33.6041 52.1505 33.6233L44.6328 33.6839C44.6328 33.6839 40.2765 33.2132 38.2195 30.8181L37.3773 29.9086C35.3582 27.6556 32.899 26.561 30.0162 26.5674C26.9488 26.5738 23.8814 26.569 20.8141 26.5706C16.1627 26.5706 10.9394 26.5514 6.28807 26.5897V21.4008C13.0162 21.4247 20.1894 21.4183 26.9192 21.4167C28.0301 21.4167 28.9762 21.7518 29.7541 22.5384C30.481 23.2724 31.2507 23.9665 31.9908 24.6909C33.9061 26.5642 36.2301 27.6062 38.9546 27.6413C43.4065 27.7003 47.8601 27.6492 52.312 27.6716C53.1394 27.6748 53.4196 27.3285 53.4048 26.5786C53.3768 25.0898 53.3966 23.5995 53.3933 22.1092C53.39 20.7849 53.3718 20.7657 52.0236 20.7657C45.724 20.7657 39.4244 20.7625 33.1231 20.7657C28.5608 20.7689 29.0981 21.0641 25.8972 17.892C23.5337 15.5496 20.758 14.3784 17.3297 14.4757C13.837 14.5747 9.784 14.4869 6.28642 14.5124V8.8384H15.5726C16.677 8.82084 17.5637 9.24847 18.3252 10.0559C19.2235 11.0084 20.0822 12.0057 20.997 12.9392C22.7161 14.6943 24.7352 15.8177 27.1153 15.8304C35.5263 15.8751 43.9373 15.848 52.3483 15.8703C53.118 15.8719 53.418 15.5512 53.4048 14.7247C53.3784 13.0333 53.3949 11.3419 53.3933 9.65057C53.3933 8.04537 53.357 8.00388 51.9065 8.00388C41.9792 8.00388 32.0501 8.02622 22.1228 7.99591C16.672 7.97995 17.9346 8.62299 14.0678 4.37383C11.9531 2.04741 9.27139 0.935259 6.29137 0.935259L0.624702 0.932068Z"
          fill="#CCFF00"
        />
      </g>
      <defs>
        <clipPath id="clip0_1255_6784">
          <rect
            width="52.7867"
            height="40.5927"
            fill="white"
            transform="translate(0.624702 0.932068)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const LogoPWA = memo(LogoPWAComponent)
